<template>
  <div class="detail-wrap">
    <el-form ref="editForm" :model="formData">
      <div class="d-header clearfix">
        <div class="fl">
          <i class="el-icon-info"/>
          {{ dataId ? '查看' : '新增' }}时间设置
        </div>
        <div class="fr">
<!--          <el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-refresh-right">重置-->
<!--          </el-button>-->
          <el-button v-if="(sfSettleTimeAdd && formData.id == null) ||(sfSettleTimeEdit && formData.id != null)" type="primary" class="button-sty" icon="el-icon-check" @click="saveData">保存</el-button>
        </div>
      </div>
      <div>

        <div class="d-cont edit-mce-box">
          <div class="d-item">
            <div class="title first">

            </div>
            <table class="table-detail">
              <tbody>
              <tr>
                <th>
                  网点名称
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="siteName" clearable readonly="true">
                    <i slot="suffix" class="el-input__icon el-icon-search" @click="showPreconditionDialog=true"></i>
                  </el-input>
                </td>

                <th>
                  <em class="f-red">*</em>
                  时间名称
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="formData.timeName" clearable/>
                </td>

                <th>
                  <em class="f-red">*</em>
                  启用
                </th>
                <td>
                  <el-select v-model="formData.usable" style="width: 165px;">
                    <el-option label="禁用" :value="0"/>
                    <el-option label="启用" :value="1"/>
                  </el-select>
                </td>

              </tr>
              <tr>
                <th>
                  <em class="f-red">*</em>
                  时间类型
                </th>
                <td>
                  <el-select v-model="formData.timeType" style="width: 165px;">
                    <el-option label="按完工时间" :value="1"/>
                    <el-option label="按网点确认完工时间" :value="2"/>
                    <el-option label="按进入结算池时间" :value="3"/>
                  </el-select>
                </td>
                <th>
                  <em class="f-red">*</em>结算时间
                </th>
                <td style="position: absolute; width: 20vw!important;
                      white-space: nowrap;
                      overflow: hidden;
                      text-overflow: ellipsis;">
                    <el-date-picker class="current-date-picker"
                                    v-model="formData.date"
                                    type="daterange"
                                    align="right"
   
                                    range-separator="-"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                                    value-format='yyyy-MM-dd'>
                    </el-date-picker>
                  </td>
                <!-- <th>
                  <em class="f-red">*</em>
                  结算开始时间
                </th>
                <td>
                  <el-date-picker
                    v-model="formData.beginDate"
                    type="datetime"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    placeholder="选择日期时间">
                  </el-date-picker>
                </td>
                <th>
                  <em class="f-red">*</em>
                  结算结束时间
                </th>
                <td>
                  <el-date-picker
                    v-model="formData.endDate"
                    type="datetime"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    placeholder="选择日期时间">
                  </el-date-picker>
                </td> -->

              </tr>
              <tr>
                <th>创建人</th>
                <td>{{ formData.createBy }}</td>
                <th>创建时间</th>
                <td>{{ formData.createTime }}</td>
              </tr>
              </tbody>
            </table>
          </div>

        </div>

      </div>
    </el-form>
    <preconditionDialog v-if="showPreconditionDialog"
                        @commit="commitSelectedRow"
                        :visiable.sync="showPreconditionDialog"
                        multi="true"
    />
  </div>
</template>
<script>
import preconditionDialog from '@/views/dialogCommon/radioSiteDialog.vue';
import Tinymce from '@/components/Tinymce';
import request from "@/router/axios";
import store from "@/store";
import api from "@/api/projectApi";
import {echoFileFormat, uploadFileFormat} from "@/util/uploadFormat";
import { mapGetters } from 'vuex';

export default {
  inject: ['reload'],
  name: 'edit',
  props: {
    _dataId: [String, Number]
  },
  components: {
    Tinymce,
    preconditionDialog,
  },
  data() {
    return {
      formData: {
        date:'',
        timeName: null,
        siteId: null,
        beginDate: null,
        endDate: null,
        timeType: null,
        usable: 1,
      },
      siteName: null,

      value1: "",
      picList: [],
      fileList: [],

      showPreconditionDialog: false,
      img_b: "",
      upload_btn: false, // 是否隐藏上传图片按钮
      radio: '1',
      showEdit: false,

      lan: 'zh_CN',
      isEdit: false,
      tabIndex: 'first',
      dataId: '',
      tenant: {
        timeType: 1,
        beginDate: '',
        endDate: '',
        usable: 1,
        tenantAttachmentDTOs: []
      },
      showProductCategoryDialog: false,

      areaProps: {
        lazy: true,
        checkStrictly: true,
        lazyLoad: this.cascaderLazyLoad
      },
      areaOption: [],
      areaValues: [],
    };
  },
  computed: {
      ...mapGetters(["permissions"])
  },
  created() {
    if (this._dataId && !isNaN(this._dataId)) this.dataId = this._dataId;
    this.sfSettleTimeAdd = this.permissions["sfSettleTimeAdd"];
    this.sfSettleTimeEdit = this.permissions["sfSettleTimeEdit"];
  },
  watch: {

  },
  mounted() {
    this.getData();
  },
  methods: {
    commitSelectedRow(data) {
      this.formData.siteId = data.id
      this.siteName = data.name
    },

    getData() {
      if (this.dataId && !isNaN(this.dataId)) {
        this.isEdit = true;
        request({
          url: api.sfSettleTime.getDataUrl,
          method: 'post',
          data: {
            id: this.dataId
          },
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          this.formData = response.data.data
          let tmpArr = []
          tmpArr.push(new Date(this.formData.beginDate))
          tmpArr.push(new Date(this.formData.endDate))
          console.log('转成啥', tmpArr)
          this.formData.date = tmpArr
          this.siteName = this.formData.siteName
        })
      }
    },

    saveData() {
      console.log(this.tenant.date,"formData.date的值");
      this.formData.beginDate=this.formData.date[0]
      this.formData.endDate=this.formData.date[1]
      console.log(this.formData.beginDate,this.formData.endDate,'55555');
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.$baseConfirm('您确定要保存吗？').then(() => {
            this.$mask.open()
            // var url = (this.isEdit ? api.sfSettleTime.updateDataUrl : api.sfSettleTime.addDataUrl);
            this.$http({
              url: api.sfSettleTime.saveDataUrl,
              method: `post`,
              data: this.formData,
              isLoading: true,
            }).then(res => {
              this.$message.success('保存成功')
              this.reload()
              this.$mask.close()
            }).catch(() => {
              this.$message.error("保存失败！");
              this.$mask.close()
            });
          });
        }
      });
    },

  },
};
</script>
<style lang="scss" scoped>
// 装图片的  大框
::v-deep.table-detail .el-upload--picture-card {
  // margin-top: 10px;
  width: 40px;
  height: 40px;
  line-height: 50px !important;
}

::v-deep .el-upload-list .el-upload-list__item {
  display: inline-block;
  width: 40px;
  height: 40px;
  margin-right: 14px;
  border-radius: 2px;
  padding: 0 !important;
  border-color: #e8e8e8;
  margin-top: 0;
  margin-bottom: 10px;
}

::v-deep .el-upload-list .el-upload-list__item .el-upload-list__item-thumbnail {
  width: 40px;
  height: 40px;
  padding: 0 !important;
  position: inherit;
  cursor: pointer;
}

// 输入框的宽度
#containt .table-detail tbody tr td .el-input {
  width: 100% !important;
  width: 165px !important;
}

.btn_zdy {
  margin: 10px 0;
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}

.btn_zdy2 {
  // 选取文件合同按钮
  // margin: 10px 60px;
  margin-top: 6px;
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy2:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}

.papers {
  margin-left: 30px;
  position: absolute;

  ::v-deep.el-upload-list .el-upload-list__item {
    display: inline-block;
    width: 147px !important;
    margin-right: 14px;
    border-radius: 2px;
    border-color: #e8e8e8;
    margin-top: 7px;
    margin-left: 15px;
    padding: 0px !important;
    background-color: #e1e1e1;
    height: 20px;
  }

}

::v-deep .vxe-grid .vxe-grid--pager-wrapper {
  position: absolute !important;
  bottom: -57px;
}
</style>
